export default __webpack_public_path__ + "static/media/Image gallery element.f42702ba.png";